import '@formatjs/intl-datetimeformat/add-all-tz';
import '@formatjs/intl-datetimeformat/locale-data/en';
import '@formatjs/intl-datetimeformat/locale-data/es';
import '@formatjs/intl-datetimeformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/en';
import '@formatjs/intl-numberformat/locale-data/es';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/polyfill';

import moment from 'moment';
import 'moment/locale/es';
import { PropsWithChildren, useEffect } from 'react';
import { IntlProvider } from 'react-intl';

if ('__setDefaultTimeZone' in Intl.DateTimeFormat) {
  (Intl.DateTimeFormat as any).__setDefaultTimeZone('America/Argentina/Buenos_Aires');
}

const LOCALE_DEFAULT = 'en';

export function AppIntlProvider(p: PropsWithChildren<{ messages: any; locale: string }>) {
  useEffect(() => {
    moment.locale(p.locale);
  }, [p.locale]);

  return (
    <IntlProvider
      defaultLocale={LOCALE_DEFAULT}
      locale={p.locale}
      messages={p.messages}
      formats={{
        date: {
          long: {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          },
          ddmm: {
            day: 'numeric',
            month: 'numeric',
          },
        },
      }}
    >
      {p.children}
    </IntlProvider>
  );
}
